import css_nc9tbx7kq8n from './css/FloatCloseButton.css';
import Div from "./Div.js";

const css = css_nc9tbx7kq8n;

export default class FloatCloseButton extends Div
{
	constructor(element)
	{
		super(element);

		this.element.addEventListener
		(
			'userengaged',
			event =>
			{
				event.stopPropagation();
				// console.error('NOT ENGAGED');
			}
		);

		this.element.addEventListener
		(
			'click',
			() =>
			{
				this.element.classList.add('closing')
			}
		);

		this.element.addEventListener
		(
			'transitionend',
			() =>
			{
				this.element.classList.remove('closing');
			}
		);
	}
	get cssText()
	{
		return css;
	}
}